import { Vue, Component, Ref } from 'vue-property-decorator'
import LiquorTree from 'liquor-tree'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import i18n from '@/lang/i18n'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import GridHeader from '@/components/GridHeader.vue'
import ActivityConceptsModalBasicForm from '@/components/activity-concepts-modal/activity-concepts-modal-basic-form/activity-concepts-modal-basic-form.vue'
import { AgGridColumnType, AgGridRowModelType } from '@/shared/models/ag-grid.model'

@Component({
    components: {
        LiquorTree,
        VtGrid,
        GridHeader,
        ActivityConceptsModalBasicForm
    }
})
export default class ActivityConceptsModal extends Vue {
    @Ref() readonly activityConceptsModal!: any
    @Ref() readonly activityConceptsModalBasicForm!: any

    private actionTitle !: string
    private items !: any
    private treeOptions !: any
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any

    constructor() {
        super()
        this.actionTitle = ''
        this.items = [
            {
                text: 'H3B21-000001',
                id: 1,
                data: { type: 'case', number: 10 },
                state: { selected: true, expanded: true },
                children: [
                    { text: 'A',
                        id: 1,
                        data: { type: 'sample', number: 10 },
                        state: { expanded: true },
                        children: [
                            { text: '1',
                                id: 1,
                                data: { type: 'portion', number: 3 },
                                state: { expanded: true },
                                children: [
                                    { text: '1', id: 1, data: { type: 'subportion', number: 3 } }
                                ] },
                            { text: '2',
                                id: 2,
                                data: { type: 'portion', number: 7 },
                                state: { expanded: true },
                                children: [
                                    { text: '1', id: 2, data: { type: 'subportion', number: 2 } },
                                    { text: '2', id: 3, data: { type: 'subportion', number: 3 } },
                                    { text: '3', id: 4, data: { type: 'subportion', number: 2 } }
                                ] }
                        ] },
                    { text: 'B', id: 2, data: { type: 'sample' } },
                    { text: 'C', id: 3, data: { type: 'sample' } },
                    { text: 'D', id: 4, data: { type: 'sample' } }
                ]
            }
        ]
        this.treeOptions = {
            checkbox: false,
            autoCheckChildren: false,
            parentSelect: true
        }
        this.selectedRows = []
        this.columnDefs = [
            { type: AgGridColumnType.MASTER_DETAIL },
            { type: AgGridColumnType.CUSTOM_CHECKBOX },
            {
                type: 'text',
                headerName: i18n.t('component.valuableConceptsModal.elementID'),
                colId: 'elementID',
                field: 'elementID',
                minWidth: 140,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('component.valuableConceptsModal.concept'),
                colId: 'concept',
                field: 'concept',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('component.valuableConceptsModal.value'),
                colId: 'value',
                field: 'value',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'checkIconRenderer',
                headerName: i18n.t('component.valuableConceptsModal.authomatic'),
                colId: 'authomatic',
                field: 'authomatic',
                minWidth: 80,
                suppressSizeToFit: true
            },
            {
                type: 'checkIconRenderer',
                headerName: i18n.t('component.valuableConceptsModal.user'),
                colId: 'user',
                field: 'user',
                minWidth: 150,
                suppressSizeToFit: true
            }
        ]
        this.rowData = [
            {
                elementID: 'A',
                concept: 'Técnico de histoquímica',
                client: 'ASISA SA',
                rate: 'ASISA 2021',
                alias: 'TÉCNICA HISTOQUÍMICA',
                reference: 'AS-230021',
                value: '15',
                authomatic: true,
                authorization: true,
                requested: false
            },
            {
                elementID: 'A-1',
                concept: 'Técnico de histoquímica',
                client: 'ASISA SA',
                rate: 'ASISA 2021',
                alias: 'TÉCNICA HISTOQUÍMICA',
                reference: 'AS-230021',
                value: '15',
                authomatic: true,
                authorization: true,
                requested: false
            },
            {
                elementID: 'A-2',
                concept: 'Técnico de histoquímica',
                client: 'ASISA SA',
                rate: 'ASISA 2021',
                alias: 'TÉCNICA HISTOQUÍMICA',
                reference: 'AS-230021',
                value: '15',
                authomatic: true,
                authorization: true,
                requested: false
            }
        ]
        this.gridApi = null
    }

    get gridOptions(): GridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: params => {
                this.onGridReady(params)
            },
            onRowSelected: params => {
                this.onRowSelected()
            }
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                }
            ]
        }
    }

    onRowSelected() {
        this.selectedRows = this.gridApi.getSelectedRows()
    }

    onGridReady({ api }: any) {
        this.gridApi = api
    }

    show() {
        this.activityConceptsModal.show()
    }

    hide() {
        this.activityConceptsModal.hide()
    }

    showActivityConceptsModalBasicForm(title: string) {
        this.actionTitle = title
        this.activityConceptsModalBasicForm.show()
    }
}
